import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../../shared/scripts/table-column-visibility";
import { PickListItem, JsonItem, IControllerFilter, CombineDisplayOption, UserRequestExtended } from "../../../list-management/scripts/list-management.objects";
import { Filter, FilterTab } from "../../../list-management/scripts/list-management.filters";
import _ from "lodash";
import { plainToClass } from "class-transformer";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";

declare var $: any;

export class PmUserTable implements IControllerFilter {
    tableId: string;
    propName: string;
    displayPropName: string;
    columns: any[];
    tableColumnGroups: TableColumnGroup[] = [];
    tableGroupController: TableColumnVisibilityControllerV2;
    tableItems: any[];
    pickLists: JsonItem[];
    table: any;
    filterTabs: FilterTab[] = [];
    defaultOrder: any[] = [];

    getItemsRoute: string;

    tableInfo: PmUserTableInfo;

    targetItem: any;

    userRequestList: UserRequestExtended[];

    constructor(tableInfo: PmUserTableInfo, userRequestList: UserRequestExtended[] = []) {
        this.tableInfo = tableInfo;
        this.tableId = tableInfo.tableId;
        this.propName = tableInfo.propName;
        this.columns = tableInfo.columns;
        this.tableColumnGroups = tableInfo.tableColumnGroups;
        this.getItemsRoute = tableInfo.getItemsRoute;
        this.filterTabs = tableInfo.tableFilters;
        this.defaultOrder = tableInfo.defaultOrder;

        this.userRequestList = userRequestList;

        this.targetItem = null;
        //this.initialize();
    }

    async initialize() {
        // Get Data
        let result: any[] = await this.getListItems();
        if (result["items"]) {
            this.tableItems = result["items"];
        }
        if (result["pickLists"]) {
            this.pickLists = plainToClass(JsonItem, <JsonItem[]>result["pickLists"]);
        }

        if (this.tableInfo.hasFilterRule) {
            this.tableItems = this.tableItems.filter(item => this.tableInfo.filterRule(item));
        }

        // Initialize Columns
        let columns = _.cloneDeep(this.columns);
        let fixedColumns = 1;
        let tableColumns: any[] = [];
        if (this.tableInfo.hasDetailMenu) {
            let firstColumn = columns.shift();
            tableColumns.push(firstColumn);
            tableColumns.push(
                { data: this.propName, title: "", width: "26px", orderable: false, className: "text-center detail-btn-container", render: (data) => this.renderDetailButton(data) }
            );
            tableColumns.push(...columns);
            fixedColumns = 2;
        }
        else {
            tableColumns = columns;
        }

        // Initialize Table Dom
        let columnSelect: string = "";
        if (this.tableInfo.tableColumnGroups.length > 0) {
            columnSelect = `<"${this.tableId}-column-select">`;
        }

        let searchBar: string = "";
        if (this.tableInfo.isSearchable) {
            searchBar = `<"${this.tableId}-search-bar"f>`;
        }

        if (this.tableInfo.hasRowClick) {
            $(`#${this.tableId}`).addClass("row-select");
        }

        let domString = `<"${this.tableId}-top-controls"${columnSelect}${searchBar}<"${this.tableId}-count-found"B>>rtip`

        this.table = $(`#${this.tableId}`).DataTable({
            "dom": domString,
            autoWidth: true,
            info: false,
            paging: false,
            search: this.tableInfo.isSearchable,
            scrollX: true,
            scrollY: "60vh",
            scrollCollapse: true,
            orderCellsTop: true,
            order: this.defaultOrder,
            fixedColumns: {
                leftColumns: fixedColumns
            },
            language:
            {
                search: "Search",
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                }
            ],
            data: this.tableItems
        });

        $(`.${this.tableId}-top-controls`).addClass('row mx-0 align-items-center');
        $(`.${this.tableId}-count-found`).addClass('col-12 col-md d-flex justify-content-end vertical-align-middle mt-3 px-0');
        //$(`.${this.tableId}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        if (this.tableInfo.tableColumnGroups.length > 0) {
            $(`.${this.tableId}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
            $(`.${this.tableId}-column-select`).empty().html(`<div id="${this.tableId}-column-select"></div>`);
        }
        if (this.tableInfo.isSearchable) {

            if (this.tableInfo.tableColumnGroups.length > 0) {
                $(`.${this.tableId}-search-bar`).addClass('col-12 col-md-3');
            }
            else {
                $(`.${this.tableId}-search-bar`).addClass('col-12 col-md-3 pl-0');
            }
        }

        if (this.tableInfo.tableColumnGroups.length > 0) {
            this.tableGroupController = new TableColumnVisibilityControllerV2(`#${this.tableId}`, `#${this.tableId}-column-select`, this.tableColumnGroups, `${this.tableId}-table-column-visibility`);
        }

        if (this.tableInfo.hasRowClick) {
            $(`#${this.tableId} tbody`).on('click', 'tr', (event) => {
                let tr = $(event.currentTarget);
                let row = this.table.row(tr);
                let currentData = row.data();
                let targetId = _.get(currentData, this.propName);
                let targetItem = this.tableItems.find(item => _.get(item, this.propName) == targetId);
                if (targetItem != undefined) {
                    this.targetItem = targetItem;
                    this.tableInfo.rowClickOnClick(targetId);
                }             
                $("#detail-menu-container").find(".revampp-dropdown-menu").removeClass("show"); 
            });
        }

        if (this.tableInfo.hasFilters) {
            this.generateFilterTabContent();
        }
    }

    generateFilterTabContent(): void {
        // Create new Tab Content
        let tabContent = "";
        let filtersContent = "";
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilter = this.filterTabs[i];
            if (i == 0) {
                tabContent += `<li class="nav-item"><a class="nav-link active" id="${currentFilter.id}-tab" data-toggle="tab" href="#${currentFilter.id}" role="tab" aria-controls="${currentFilter.id}" aria-selected="true">${currentFilter.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade show active" id="${currentFilter.id}" role="tabpanel" aria-labelledby="${currentFilter.id}-tab"><div class='row'>`
            }
            else {
                tabContent += `<li class="nav-item"><a class="nav-link" id="${currentFilter.id}-tab" data-toggle="tab" href="#${currentFilter.id}" role="tab" aria-controls="${currentFilter.id}" aria-selected="false">${currentFilter.displayName}</a></li>`
                filtersContent += `<div class="tab-pane fade" id="${currentFilter.id}" role="tabpanel" aria-labelledby="${currentFilter.id}-tab"><div class='row'>`
            }

            for (let j = 0; j < currentFilter.filters.length; j++) {
                let filter = currentFilter.filters[j];
                filtersContent += filter.generateFilterHtml();
            }

            filtersContent += `</div></div>`
        }

        // Update Tabs
        $(`#pm-table-filter-tabs-${this.tableId}`).empty().html(tabContent);
        if (this.filterTabs.length == 1) {
            // Hide tabs when there is only one
            $(`#pm-table-filter-tabs-${this.tableId}`).addClass("d-none");
        }

        $(`#pm-table-filter-container-${this.tableId}`).empty().html(filtersContent);

        // Generate Dropdown
        for (let i = 0; i < this.filterTabs.length; i++) {
            let currentFilterTab = this.filterTabs[i];
            for (let j = 0; j < currentFilterTab.filters.length; j++) {
                let currentFilter = currentFilterTab.filters[j];
                if (currentFilter.pickListName) {
                    let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == currentFilter.pickListName).Json;
                    if (foundPickList) {
                        currentFilter.initializeDropdown(this.tableItems, this, foundPickList);
                    }
                }
                else {
                    currentFilter.initializeDropdown(this.tableItems, this);
                }
            }
        }

        this.filterTabs.forEach(tab => {
            if (tab.columnViewName) {
                $(`#${tab.id}-tab`).on('click', () => {
                    $(`#column-filter-dropdown-${this.tableId}-table-column-visibility`).val([`${tab.columnViewName}`])
                    $(`#column-filter-dropdown-${this.tableId}-table-column-visibility`).trigger("change");
                })
            }
        });
    }

    triggerFilter(): void {
        let filteredItems: any[] = _.cloneDeep(this.tableItems);

        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                filteredItems = filter.filterItems(filteredItems);
            })
        });

        this.updateTable(filteredItems);
    }

    resetFilters(): void {
        this.filterTabs.forEach(tab => {
            tab.filters.forEach(filter => {
                if (filter.type == "date-before" || filter.type == "date-after") {
                    filter.setSelected("");
                }
                else {
                    filter.resetFilter();
                }
            })
        })
    }

    updateTable(items: any[]) {
        // Removes any shown menus
        $(`#detail-menu-container-${this.tableId}`).empty();

        this.table.clear();
        this.table.rows.add(items).draw();
    }

    resizeTable(): void {
        if (this.table) {
            this.table.columns.adjust().draw();
        }
    }

    renderDetailButton(data: any): string {

        let content = `
            <div class="btn-group dropright">
                <button type="button" class="btn dropdown-toggle p-0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onclick="page.${this.tableInfo.tableVariableName}.updateMenuPosition(event)">
                    <div class="item-detail-button" data-id="${data}"><div><i class="fa-solid fa-ellipsis"></i></div></div>
                </button>
                <div class="dropdown-menu revampp-dropdown-menu">
                    
                </div>
            </div>
        `
        return content;
    }

    updateMenuPosition(e: Event) {
        // set current selected row
        let targetElement = <JQuery<HTMLElement>>$(e.currentTarget);
        this.setTargetedRow(targetElement);

        // empty any existing menus (menus are moved to this div to avoid overflow issues with table)
        $(`#detail-menu-container-${this.tableId}`).empty();

        let dropdownMenu = targetElement.siblings('.revampp-dropdown-menu');
        let dropdownContainer = targetElement.parent();

        // Check is the dropdown menu has been moved to the new #detail-menu-container 
        if (dropdownMenu.length <= 0) {
            // if the menu has already been moved, remove existing dropdwon relationship, and create a new one with new menu options
            targetElement.dropdown('dispose');
            dropdownContainer.append(`
                <div class="dropdown-menu revampp-dropdown-menu">
                    ${this.getMenuContent()}
                </div>
            `)
            targetElement.dropdown();
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find('.revampp-dropdown-menu');
                $(`#detail-menu-container-${this.tableId}`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu))
            });
        }
        else {
            // if the menu has not already been moved (first click), just add the correct menu options.
            dropdownMenu.html(`
                ${this.getMenuContent()}
            `)
            // move the updated menu to #detail-menu-container when its shown
            dropdownContainer.off().on("show.bs.dropdown", (e) => {
                let updatedDropdownMenu = dropdownContainer.find(".revampp-dropdown-menu");
                $(`#detail-menu-container-${this.tableId}`).append(<JQuery<HTMLElement>>$(updatedDropdownMenu));
            });
        }
    }

    setTargetedRow(target: JQuery<HTMLElement>): void {
        let tr = $(target).closest('tr');
        let row = this.table.row(tr);
        let currentData = row.data();
        let targetId = _.get(currentData, this.propName);
        let foundItem = this.tableItems.find(item => _.get(item, this.propName) == targetId);
        if (foundItem != undefined) {
            this.targetItem = foundItem;
        }
    }

    getMenuContent(): string {
        let menuOptions = "";

        let displayVal = _.get(this.targetItem, this.tableInfo.displayPropName);
        
        if (displayVal) {
            if (this.userRequestList.length > 0) {
                let foundUserUpdateRequests: UserRequestExtended[] = this.userRequestList.filter(request => request.UpdateUserRequest.Email == displayVal && request.UserRequest.StatusId < 3);
                if (foundUserUpdateRequests.length > 0) {
                    menuOptions += `<div class="font-size14 px-4 pt-1 pb-2 border-bottom font-weight-600"><i class="fa-solid fa-triangle-exclamation fa-lg caution-icon pr-2"></i> This user has ${foundUserUpdateRequests.length} update(s) in progress</div>`
                }
                else {
                    menuOptions += `<div class="font-weight-bold font-size14 px-4 py-1">${displayVal}</div>`
                }
            }
            else {
                menuOptions += `<div class="font-weight-bold font-size14 px-4 py-1">${displayVal}</div>`
            }
            
        }
        
        this.tableInfo.tableMenuItems.forEach(option => {
            menuOptions += `<a class="dropdown-item" onclick="${option.onClick}"><i class="${option.displayIcon} dropdown-icon pr-2"></i> ${option.displayName}</a>`
        });

        return menuOptions;
    }

    getMultiSelectString(pipeSeparatedIds: string, pickListName: string): string {
        if (!pipeSeparatedIds) {
            return "";
        }

        let stringArrIds: string[] = pipeSeparatedIds.split("|");
        stringArrIds = _.uniq(stringArrIds);
        let pickList: PickListItem[] = this.pickLists.find(item => item.Id == pickListName)?.Json;

        if (!stringArrIds || !pickList) {
            return pipeSeparatedIds;
        }

        let returnStrArray: string[] = [];
        let returnStr: string = "";

        for (let i = 0; i < stringArrIds.length; i++) {
            let numId: number = parseInt(stringArrIds[i]);
            if (numId) {
                let foundItem = pickList.find(item => item.Id == numId);
                if (foundItem) {
                    returnStrArray.push(foundItem.Value)
                }
            }
        }

        returnStrArray.sort((x1: string, x2: string) => x1.localeCompare(x2));
        returnStr = returnStrArray.join(", ");

        return returnStr;
    }

    getDisplayContent(dataArr: any[], propName: string, pickListName: string = ""): string {
        let content = dataArr.map(item => _.get(item, propName));
        content = _.uniq(content);
        content.sort();
        let returnContent = "";
        if (pickListName) {
            let returnContentArr = [];
            let pickListItem = this.pickLists.find(list => list.Id == pickListName);
            if (pickListItem) {
                let pickList: PickListItem[] = pickListItem.Json;
                for (let i = 0; i < content.length; i++) {
                    let foundVal = pickList.find(item => item.Id == content[i]);
                    if (!foundVal) {
                        continue;
                    }
                    returnContentArr.push(foundVal.Value);
                }
                returnContentArr.sort();
                returnContent = returnContentArr.join(', ');
            }
        }
        else {
            returnContent = content.join(', ');
        }
        return returnContent;
    }

    getCombinedContent(data: any[], combineDisplayOptions: CombineDisplayOption[]) {
        let returnContent = "";
        if (data.length == 0) {
            return returnContent;
        }

        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDisplay = "";
            for (let j = 0; j < combineDisplayOptions.length; j++) {
                let options = combineDisplayOptions[j];
                let prop = _.get(item, options.propName);
                if (prop) {
                    let pickList: PickListItem[] = this.pickLists.find(list => list.Id == options.pickListName)?.Json;
                    if (pickList) {
                        let foundVal: PickListItem = pickList.find(target => target.Id.toString() == prop.toString());
                        if (foundVal) {
                            itemDisplay += `${options.prevContent}${foundVal.Value}${options.endContent}`;
                        }
                    }
                }
            }
            returnContent += itemDisplay;

            if (i < (data.length - 1)) {
                returnContent += "<hr class='my-1'>"
            }
        }

        return returnContent;
    }

    getPickListContent(itemId: any, pickListName: string = ""): string {
        let returnContent = "";
        if (itemId == null || itemId == undefined) {
            return returnContent;
        }
        if (pickListName) {
            let pickListItem = this.pickLists.find(list => list.Id == pickListName);
            if (pickListItem) {
                let pickList: PickListItem[] = pickListItem.Json;
                let foundVal = pickList.find(item => item.Id == itemId);
                if (foundVal) {
                    returnContent = foundVal.Value;
                }
            }
        }
        return returnContent;
    }

    getYesNoDisplay(data: any): string {
        // If Truthy
        if (data) {
            return "<div class='revampp-active-block'>Yes</div>";
        }
        // If Falsey
        else {
            return "<div class='revampp-inactive-block'>No</div>";
        }
    }

    getDisplayEmail(email: string): string {
        // Search for any in-progress requests
        let foundUserUpdateRequests: UserRequestExtended[] = this.userRequestList.filter(request => request.UpdateUserRequest.Email == email && request.UserRequest.StatusId < 3);

        if (foundUserUpdateRequests.length == 0) {
            return email;
        }
        else {
            return `${email} <i class="fa-solid fa-user-gear pl-2"></i>`
        }
    }

    getDisplayStatus(statusId: number): string {
        if (statusId == 1) {
            return `<div class="revampp-review-block">PM Review</div>`
        }
        else if (statusId == 2) {
            return `<div class="revampp-inactive-block">CDSC Review</div>`
        }
        else if (statusId == 3) {
            return `<div class="revampp-active-block">Completed</div>`
        }
        else if (statusId == 4) {
            return `<div class="revampp-hidden-block">PM Disapproved</div>`
        }
        else if (statusId == 5) {
            return `<div class="revampp-hidden-block">CDSC Disapproved</div>`
        }
        else {
            return `<div class="revampp-unknown-block">Unknown</div>`
        }
    }

    async getListItems() {
        let result: any;
        try {
            result = await $.ajax({
                url: `${this.getItemsRoute}`,
                method: "GET",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                cache: false
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}

export class PmUserTableInfo {
    tableId: string; // existing html element to identify where the table should be placed
    propName: string; // Unique Identifier for item in table
    columns: any[]; // Columns in the table
    tableColumnGroups: TableColumnGroup[] = []; // if this is empty or not defined, don't include "Columns to View"
    hasFilters: boolean = false; // include filters for the table
    tableFilters: FilterTab[] = [];
    isSearchable: boolean = false; // include a search bar at the top of the table
    hasRowClick: boolean = false; // click on a row to bring up a modal
    rowClickOnClick: (itemId: number) => void; // method to call when a row is clicked, propName info will be passed in (unique Id)
    hasDetailMenu: boolean = false; // include a detail menu button (like List Management)
    tableMenuItems: TableMenuItem[] = []; // If it has a detail menu, these are used to generate the options
    displayPropName: string; // Used to indicate the selected item
    getItemsRoute: string; // Route Used to send a get request to model for table informaiton
    tableVariableName: string;
    hasFilterRule: boolean = false;
    filterRule: (data: any) => boolean;
    defaultOrder: any[] = [];
}

export class TableMenuItem {
    id: string;
    displayName: string;
    displayIcon: string = `fa-solid fa-pen-to-square`;
    onClick: string;

    constructor(id: string, displayName: string, onClick: string, displayIcon: string = `fa-solid fa-pen-to-square`) {
        this.id = id;
        this.displayName = displayName;
        this.displayIcon = displayIcon;
        this.onClick = onClick;
    }
}